import MapChartOperations from "../models/core/controller/MapChartOperations";
import ControllerOperations from "../models/core/controller/ControllerOperations";
import ControllerEvent from "../models/core/controller/ControllerEvent";
import WebMapConstraints from "../models/layoutOverlayMap/map/WebMapConstraints";
import { ResizeObserver } from '@sas-dvr/ltjs-commons/vender/juggle/resize-observer/ResizeObserver';
import ArcGISBackground from './ArcGISBackground';
/*
* Outstanding issues:
*
* - Graph opacity needs to be masked to the map background area: GRAPHCOMPNTS-4196.
* - What WebMapConstraints should we used? GRAPHCOMPNTS-4151.
* - Map bounds and extent initialization lag: GRAPHCOMPNTS-4151.
*
* TODO:
*
* - Add the actual ArcGISBackground (import ArcGIS).
* - Styles should be set up elsewhere (less file?).
*/
var StackedWebmapDisplay = /** @class */ (function () {
    function StackedWebmapDisplay() {
        this._graph = null;
        this._graphCanvas = null;
        this._webmapContainer = null;
        this._resizeObserver = null;
        this._boundsChangedHandle = null;
        this._viewChangingHandle = null;
        this._mapProviderChangedHandle = null;
        this._mco = null;
        this._mcoPromise = null;
        this._webmap = null;
        this._injectedBackground = null;
    }
    StackedWebmapDisplay.prototype.create = function (baseModel, _baseView, graphCanvas, webmapContainer) {
        var _this = this;
        var _a, _b;
        this.destroy();
        this._graph = baseModel === null || baseModel === void 0 ? void 0 : baseModel.retain();
        if (!this._graph) {
            console.error("Cannot create stacked webmap without access to Graph.");
            return;
        }
        this._graphCanvas = graphCanvas;
        this._webmapContainer = webmapContainer;
        // MAP TODO: This style should be applied elsewhere.  And needs to remove opacity only on masked map area.  And it doesn't work here.
        this._graph.setOpaque(false);
        // MAP TODO: This style should be applied elsewhere.
        this._webmapContainer.style.position = "absolute";
        var layoutOverlayMap = this._graph.getLayout();
        if (!this._graph) {
            console.error("Cannot create stacked webmap.  Layout does not contain a map.");
            return;
        }
        this.acquireMapChartOperations(layoutOverlayMap);
        this._webmap = (this._injectedBackground) ? this._injectedBackground : new ArcGISBackground();
        // Update map provider before creating webmap.
        this.handleMapProviderChanged();
        (_a = this._mcoPromise) === null || _a === void 0 ? void 0 : _a.then(function (mco) {
            _this._mapProviderChangedHandle = mco.attachEvent(MapChartOperations.MAP_PROVIDER_CHANGED, _this.handleMapProviderChanged.bind(_this));
        });
        this._webmap.create(this._webmapContainer);
        // Synchronize container sizes.
        this.synchronizeContainerSizes();
        this._resizeObserver = new ResizeObserver(this.synchronizeContainerSizes.bind(this));
        this._resizeObserver.observe(this._graphCanvas);
        // Synchronize map background screen coordinates and geographic extents.
        (_b = this._mcoPromise) === null || _b === void 0 ? void 0 : _b.then(function (mco) {
            _this._boundsChangedHandle = mco.attachEvent(MapChartOperations.MAP_BOUNDS_CHANGED, _this.handleBoundsChanged.bind(_this));
            _this._viewChangingHandle = mco.attachEvent(MapChartOperations.MAP_VIEW_CHANGING, _this.handleViewChanging.bind(_this));
        });
        this.setWebMapConstraints(); // MAP TODO: set up only after webmap has loaded.
    };
    StackedWebmapDisplay.prototype.destroy = function () {
        var _a, _b, _c, _d, _e, _f;
        // Shutdown interactivity.
        (_a = this._boundsChangedHandle) === null || _a === void 0 ? void 0 : _a.detach();
        (_b = this._viewChangingHandle) === null || _b === void 0 ? void 0 : _b.detach();
        (_c = this._mapProviderChangedHandle) === null || _c === void 0 ? void 0 : _c.detach();
        // Delete ArcGIS resources.
        if (this._webmap) {
            this._webmap.destroy();
            this._webmap = null;
        }
        // Clear the ltjs reservations.
        this._mcoPromise = null;
        (_d = this._mco) === null || _d === void 0 ? void 0 : _d.release();
        this._mco = null;
        (_e = this._graph) === null || _e === void 0 ? void 0 : _e.release();
        (_f = this._resizeObserver) === null || _f === void 0 ? void 0 : _f.disconnect();
        this._resizeObserver = null;
        this._graph = null;
        this._graphCanvas = null;
        this._webmapContainer = null;
    };
    StackedWebmapDisplay.prototype.handleMapProviderChanged = function () {
        var _a, _b;
        // Find the first map provider in the LayoutOverlayMap.
        var layoutOverlayMap = (_a = this._graph) === null || _a === void 0 ? void 0 : _a.getLayout();
        if (!layoutOverlayMap)
            return;
        var provider = null;
        for (var _i = 0, _c = (layoutOverlayMap.getContent() || []); _i < _c.length; _i++) {
            var layer = _c[_i];
            provider = (_b = layer === null || layer === void 0 ? void 0 : layer.getMapLayer()) === null || _b === void 0 ? void 0 : _b.getMapProvider();
            if (provider)
                break;
        }
        // Update the webmap.
        this.updateWebmapProvider(provider);
    };
    StackedWebmapDisplay.prototype.handleBoundsChanged = function () {
        var _a, _b;
        (_a = this._webmap) === null || _a === void 0 ? void 0 : _a.updateBounds(this.getMapBounds());
        (_b = this._webmap) === null || _b === void 0 ? void 0 : _b.updateExtent(this.getExtent());
    };
    StackedWebmapDisplay.prototype.handleViewChanging = function () {
        var _a;
        (_a = this._webmap) === null || _a === void 0 ? void 0 : _a.updateExtent(this.getExtent());
    };
    // Returns the map's geographic extent.
    StackedWebmapDisplay.prototype.getExtent = function () {
        if (!this._mco)
            return [0, 0, 0, 0];
        else
            return this._mco.getMapDataBounds();
    };
    // Returns the position of the map area (in pixels) within the graph.
    StackedWebmapDisplay.prototype.getMapBounds = function () {
        if (!this._mco)
            return [0, 0, 0, 0];
        else
            return this._mco.getMapBounds();
    };
    StackedWebmapDisplay.prototype.acquireMapChartOperations = function (lom) {
        var _this = this;
        this._mcoPromise = new Promise(function (resolve) {
            lom.attachEventOnce(ControllerOperations.CONTROLLER_EVENT_TYPE, function (e) {
                if (e instanceof ControllerEvent) {
                    var controller = e.getControllerOperations();
                    if (controller instanceof MapChartOperations)
                        resolve(controller.retain());
                }
            });
        });
        this._mcoPromise.then(function (resolvedMco) {
            _this._mco = resolvedMco;
        });
    };
    StackedWebmapDisplay.prototype.synchronizeContainerSizes = function () {
        var _a, _b;
        if (this._webmapContainer) {
            this._webmapContainer.style.width = ((_a = this._graphCanvas) === null || _a === void 0 ? void 0 : _a.width) + "px";
            this._webmapContainer.style.height = ((_b = this._graphCanvas) === null || _b === void 0 ? void 0 : _b.height) + "px";
        }
    };
    // MAP TODO: Remove this scaffolding.  After webmap is ready, set 
    // constraints on LayoutOverlayMap.
    StackedWebmapDisplay.prototype.setWebMapConstraints = function () {
        var _a;
        (_a = this._mcoPromise) === null || _a === void 0 ? void 0 : _a.then(function (mco) {
            mco.setWebMapConstraints(new WebMapConstraints('102100', [-20037508.231, -19971868.88, 40075016.463, 39943737.761], 9027.977));
        });
        // // https://epsg.io/3857
        // // https://developers.arcgis.com/documentation/mapping-apis-and-services/reference/zoom-levels-and-scale/#:~:text=Since%20the%20maximum%20zoom%20level,exist%20for%20image%20tile%20layers.
        // // Note that 1:35.2655368 is the scale "House" level, which is zoom level 23 for vector tiles,
        // // the maximum listed in ArcGIS's "Zoom level to scale converter".
        // const maxXY = Math.PI * 6378137;
        // const minXY = -maxXY;
        // const widthHeight = maxXY - minXY;
        // // [-20037508.342789244, -20037508.342789244, 40075016.68557849, 40075016.68557849]
        // mco.setWebMapConstraints(new WebMapConstraints("102100", [minXY, minXY, widthHeight, widthHeight], 35.2655368));
    };
    StackedWebmapDisplay.prototype.updateWebmapProvider = function (provider) {
        var _a;
        (_a = this._webmap) === null || _a === void 0 ? void 0 : _a.updateProviderInfo((provider === null || provider === void 0 ? void 0 : provider.getURL()) || "", (provider === null || provider === void 0 ? void 0 : provider.getBasemap()) || "", (provider === null || provider === void 0 ? void 0 : provider.getPortalItemId()) || "", (provider === null || provider === void 0 ? void 0 : provider.getApiKey()) || "", (provider === null || provider === void 0 ? void 0 : provider.getToken()) || "");
    };
    // Use an injected background to substitute for the default ArcGISBackground
    // provided by the framework.  It is designed solely to allow rapid
    // testing of ArcGIS changes from external clients.
    StackedWebmapDisplay.prototype.injectBackground = function (background) {
        this._injectedBackground = background;
    };
    return StackedWebmapDisplay;
}());
export default StackedWebmapDisplay;
